<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormSubmitted }}</h2>

        {{ store.lexicon[store.culture].PRFormSubmitted1 }}
        <strong>{{ store.lexicon[store.culture].PRFormSubmitted2 }}</strong>
        {{ store.lexicon[store.culture].PRFormSubmitted3 }}
    </div>
</template>

<script setup>
    import { useStore } from './store';

    const store = useStore();
</script>